import { http } from 'shared/api/http'; // sende farklıysa yolu düzelt

const BASE = '/api/v1/pilates/activities';

export const activitiesApi = {
  async list() {
    return http(BASE, { method: 'GET' });
  },

  async create(payload) {
    return http(BASE, { method: 'POST', body: payload });
  },

  async update(id, payload) {
    return http(`${BASE}/${id}`, { method: 'PUT', body: payload });
  },

  // soft delete
  async setActive(id, active) {
    return http(`${BASE}/${id}/active`, { method: 'PATCH', body: { active } });
  },
  remove: (id) => http(`${BASE}/${id}`, { method: 'DELETE' }),
};
